import React, { useState } from "react";
import { Button, Icon, Confirm } from "semantic-ui-react";
import { Newsletter } from "../../../../api";
import { useAuth } from "../../../../hooks";
import "./EmailItem.scss";

const newsLetterController = new Newsletter();

export function EmailItem(props) {
  const { accessToken } = useAuth();
  const { email, onReload } = props;
  const [showConfirm, setShowConfirm] = useState(false);

  const onOpenCloseconfirm = () => setShowConfirm((prevState) => !prevState);
  //creo funcion onDelete con un try catch y console.log
  const onDelete = async () => {
    try {
      await newsLetterController.deleteEmail(accessToken, email._id);
      onReload();
      onOpenCloseconfirm();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="email-item">
        <span>{email.email}</span>

        <div>
          <Button icon color="red" onClick={onOpenCloseconfirm}>
            <Icon name="trash" />
          </Button>
        </div>
      </div>
      <Confirm
        open={showConfirm}
        onCancel={onOpenCloseconfirm}
        onConfirm={onDelete}
        content={`¿Estás seguro de que quieres eliminar el email ${email.email}?`}
        size="mini"
      />
    </>
  );
}
